import React, { Component } from 'react';
import Backend from '../../Layouts/Backend';
import { withTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import helper from '../../../utils/helper';

class Reports extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;
    return (
      <Backend>
        <div className="content-inner">
          <div>
            {helper.checkPermission('API.Reports.AlarmHistory') && (
              <NavLink to="/reports/alarm-history" className="configure-item">
                {t('Alarm History')}
              </NavLink>
            )}
          </div>
          <div>
            {helper.checkPermission('API.Reports.Audits') && (
              <NavLink to="/reports/audit-reports" className="configure-item">
                {t('Audit Reports')}
              </NavLink>
            )}
          </div>
          <div>
            {helper.checkPermission('API.Reports.BatchReports') && (
              <NavLink to="/reports/batch-reports" className="configure-item">
                {t('Batch Reports')}
              </NavLink>
            )}
          </div>
          <div>
            {helper.checkPermission('API.Reports.GroupStatus') && (
              <NavLink to="/reports/group-status" className="configure-item">
                {t('Group Status')}
              </NavLink>
            )}
          </div>
          <div>
            {helper.checkPermission('API.Reports.GroupStatusStatistics') && (
              <NavLink
                to="/reports/group-status-statistics"
                className="configure-item"
              >
                {t('Group Status (Statistics)')}
              </NavLink>
            )}
          </div>
          <div>
            {helper.checkPermission('API.Reports.LimitsChanged') && (
              <NavLink to="/reports/limits-changed" className="configure-item">
                {t('Limits Changed')}
              </NavLink>
            )}
          </div>
          <div>
            {helper.checkPermission('API.Reports.MKTMonitors') && (
              <NavLink to="/reports/mkt-monitors" className="configure-item">
                {t('MKT Monitors')}
              </NavLink>
            )}
          </div>
          <div>
            {helper.checkPermission('API.Reports.MeasurementLog') && (
              <NavLink
                to="/reports/sensor-measurement-log"
                className="configure-item"
              >
                {t('Sensor Measurement Log')}
              </NavLink>
            )}
          </div>
          <div>
            {helper.checkPermission('API.Reports.Sensor') && (
              <NavLink to="/reports/sensor-report" className="configure-item">
                {t('Sensor Report')}
              </NavLink>
            )}
          </div>
          <div>
            {helper.checkPermission('API.Reports.StatisticsDetail') && (
              <NavLink
                to="/reports/statistics-detail"
                className="configure-item"
              >
                {t('Statistics Detail')}
              </NavLink>
            )}
          </div>
          <div>
            {/* {helper.checkPermission('API.Reports.AlarmHistory') && (
              <NavLink to="/reports/trend-chart" className="configure-item">
                {t('Trend Chart')}
              </NavLink>
            )} */}
            <NavLink to="/reports/trend-chart" className="configure-item">
              {t('Trend Chart')}
            </NavLink>
          </div>
          <div>
            {helper.checkPermission('API.Reports.UserNotes') && (
              <NavLink to="/reports/user-notes" className="configure-item">
                {t('User Notes')}
              </NavLink>
            )}
          </div>
        </div>
      </Backend>
    );
  }
}

export default withTranslation('app')(Reports);
